/* import __COLOCATED_TEMPLATE__ from './restaurant.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';

/**
## Svgs::Illustrations::Restaurants::Restaurant

Displays the "Restaurant" illustration from the [Square Illustration 2D Modular
library](https://www.figma.com/design/vL3E6QILnWsajqJFpaU5G5/Square-Illustration-2D-Modular-Library?node-id=104-17616)
*/

export default class Restaurant extends SvgIcon {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "height", 96);
    _defineProperty(this, "width", 96);
    _defineProperty(this, "viewBox", '0 0 96 96');
    _defineProperty(this, "defaultColor", 'currentColor');
    _defineProperty(this, "fill", 'none');
  }
}